export default __webpack_public_path__ + "static/media/s2.a6bbf830.svg";